export const openGroupPagerJump = (button) => {
    const input = button.closest('.group-pager-jump').querySelector('input');

    button.hidden = true;
    input.hidden = false;
    input.focus();
};

export const closeGroupPagerJump = (input) => {
    input.value = '';
    input.classList.remove('error');
    input.hidden = true;
    input.closest('.group-pager-jump').querySelector('button').hidden = false;
};

export const jumpToGroupPage = (input) => {
    if (!/^\d+$/.test(input.value.trim())) {
        input.classList.add('error');
        return;
    }

    input.dispatchEvent(new CustomEvent('pagerjump'));
};
